@if (question.question.additionalPropertiesParsed.Info) {
<div
  class="info-html-container"
  [innerHtml]="
    question.question.additionalPropertiesParsed.Info
      | replacePlaceholder
      | safe : 'html'
  "
></div>
} @else { No information has been given. }
